<template>
  <l-fixed-window>
    <v-tabs grow slot="fixed-top" v-model="tabs">
      <v-tab href="#common">全局配置</v-tab>
      <v-tab href="#groupConfig">分组配置</v-tab>
      <v-tab href="#personConfig">个人配置</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <div>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="'common'">
          <common-Config  :status-prop="'readonly'" :owner-type-prop="'common'"></common-Config>
        </v-tab-item>
        <v-tab-item :value="'groupConfig'" >
          <config-list  :owner-type="'group'"></config-list>
        </v-tab-item>
        <v-tab-item :value="'personConfig'" >
          <config-list  :owner-type="'object'"></config-list>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </l-fixed-window>
</template>

<script>
import commonConfig from './commonConfig'
import configList from './configList'
export default {
  name: 'registerConfig',
  components: {
    commonConfig, configList
  },
  data () {
    return {
      tabs: null
    }
  }
}
</script>

<style scoped>

</style>
